/**
 * @ignore
 */
export enum Role {
  USER = 'user',
  ROOT = 'root',
  CUSTOMER = 'customer',
  CLIENT = 'client',
  ADMIN = 'admin',
  FILIALADMIN = 'filialAdmin',
  WORKER = 'worker'
}

export enum userType {
  BASIC = 'basic',
  PREMIUM = 'premium',
  SIMPLE = 'simple',
}
